import { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardHeader, CardContent } from './ui/Card';
import { Button } from './ui/Button';
import { APP_CONFIG } from '../config/settings';

interface ThankYouCardProps {
  onRestart: () => void;
  wasQueued?: boolean;
}

export function ThankYouCard({
  onRestart,
  wasQueued = false,
}: ThankYouCardProps) {
  const { t } = useLanguage();

  useEffect(() => {
    const timer = setTimeout(() => {
      onRestart();
    }, APP_CONFIG.THANK_YOU_DURATION * 1000);

    return () => clearTimeout(timer);
  }, [onRestart]);

  return (
    <Card variant="end">
      <CardHeader>
        <div></div>
        <div></div>
      </CardHeader>

      <CardContent>
        <div className="text-center">
          <h1 className="text-xl text-bold mb-l">{t('thankyou')}</h1>

          <p className="text-l mb-m">{t('rec')}</p>

          {wasQueued && (
            <p
              className="text-s mb-xl"
              style={{ color: 'var(--color-text-secondary)' }}
            >
              {t('offlineMessage')}
            </p>
          )}

          {!wasQueued && <div className="mb-xl"></div>}

          <div className="center-button mt-xl">
            <Button onClick={onRestart}>{t('restart')}</Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
